import { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContextNew';
import { UserRole, ROLE_PERMISSIONS, RolePermissions, composeRolePermissions } from '../types/user';

export const useRole = () => {
  const { userProfile, effectiveRole, orgAdminIds, loading: userLoading } = useUser();
  const [role, setRole] = useState<UserRole>('athlete');
  const [permissions, setPermissions] = useState<RolePermissions>(ROLE_PERMISSIONS.athlete);
  const [permissionsReady, setPermissionsReady] = useState(false);

  useEffect(() => {
    if (userProfile) {
      // Use effectiveRole if available (for super_admin viewing as another role)
      const userRole = (effectiveRole || userProfile.role || 'athlete') as UserRole;
      setRole(userRole);

      // School-scoped capability composes from the server-minted org_admin[]
      // claim, not the role string (HIERARCHY_SPEC §2): a district_admin who
      // also runs a school keeps the school-admin console. Skipped under a
      // super_admin "view as" override so the preview shows that role alone.
      setPermissions(composeRolePermissions(userRole, orgAdminIds, !!effectiveRole));
      setPermissionsReady(true);
    } else if (!userLoading) {
      // User loading is done but no profile - set to athlete
      setRole('athlete');
      setPermissions(ROLE_PERMISSIONS.athlete);
      setPermissionsReady(true);
    }
  }, [userProfile, effectiveRole, orgAdminIds, userLoading]);

  // Loading is true if user is loading OR permissions haven't been computed yet
  const loading = userLoading || !permissionsReady;

  return { role, permissions, loading };
};